import { preload } from 'react-dom';

import { IMG } from '../../const';
import './loader.scss';

const PendingState = () => {
  preload(`${IMG.QUICK_QUOTE}/meditation-loader.gif`, { as: 'image' });

  return (
    <div className="report-page__loader">
      <p>
        <strong>Analyzing the requirements</strong>
      </p>
      <img
        src={`${IMG.QUICK_QUOTE}/meditation-loader.gif`}
        alt="Meditation"
        width="354"
        height="354"
      />
      <div className="report-page__loader-text">
        <h3>DON'T CLOSE THE WINDOW!</h3>
        <p>
          <strong>
            AI is generating the result, this will only take a few seconds.
          </strong>
        </p>
      </div>
    </div>
  );
};

export default PendingState;
